import {getNextSibling, mediaQueryBreakpointSM} from "../Utils/Utils.js";

const WPBlockCoverScrollDownBtn = (domEl) => {

	const btn = domEl.querySelector('.scroll-down-btn');
	if(!btn) {
		return;
	}

	btn.addEventListener('click', (e) => {
		e.preventDefault();

		const nextSibling = getNextSibling(domEl, ':not(.wp-block-acf-anchor-links):not(.wp-block-acf-book-room-parameter-booking)');

		if(nextSibling) {
			const rect = nextSibling.getBoundingClientRect();
			window.scrollTo({
				top: rect.top + window.scrollY - ( window.innerWidth < mediaQueryBreakpointSM ? 100 : 132 ), // Minus the header...,
				behavior: "smooth",
			});
		}
	});
};

export default WPBlockCoverScrollDownBtn;